<template>
  <el-dropdown
    @visible-change="toggle"
    @command="changeLanguage"
    popperClass="language"
    placement="bottom"
    width="200"
    trigger="click">

    <strong class="el-dropdown-link flat" :class="{'is-active':open}" :aria-expanded="!!open ? 'true' : 'false'">
      {{ $t('common.language.'+locale) }}
    </strong>

    <el-dropdown-menu slot="dropdown" class="type-header language-list">
      <strong class="menu-title">{{$t('common.title.changeLanguage')}}</strong>
      <div class="menu-wrap">
        <el-dropdown-item
          v-for="(lang, index) in languages"
          :key="index"
          :command="lang"
          :class="{'is-active':lang==locale}">
          {{ $t('common.language.'+lang) }}
        </el-dropdown-item>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {setCookie} from '@/util/methods';

  export default {
    data() {
      return {
        open: false
      };
    },
    computed: {
      ...mapGetters({
        languages: 'i18n/languages',
        locale: 'i18n/locale',
      })
    },
    methods: {
      changeLanguage(lang) {
        const pathArr = this.$route.path.split('/');
        pathArr[1] = lang;
        setCookie('langCode', lang);
        this.$bar.start();
        location.replace(pathArr.join('/'));
      },
      toggle(appear) {
        this.$emit('opened', appear);
        this.open = appear;
      }
    }
  }
</script>
